import { Provider } from '@angular/core';
import { ApplicationPropertyStore } from '@processpuzzle/base-widget';
import { CustomApplicationPropertyMapper } from './custom-application-property.mapper';
import { CustomApplicationPropertyService } from './custom-application-property.service';
import { CustomApplicationPropertyStore } from './custom-application-property.store';

/**
 * The application properties the header's like button reads and writes, served by this application's own backend
 * for the organization in the URL (`.../organizations/<orgKey>/application-properties`).
 *
 * Without this the like button throws `NG0201` as soon as a header that holds one renders — the Preview, the
 * published application — because core's `ApplicationPropertyStore` is `providedIn: 'root'` but needs an
 * `ApplicationPropertyService`, which only the testbed provides, and its own resolves `THIRD_PARTY_ROOT` (the
 * testbed's json-server). The error is thrown during change detection, which aborts the rest of that pass, so
 * everything that arrives asynchronously on the page — translations among it — is never painted.
 *
 * The second entry binds the custom store to **core's token**. `LikeButtonComponent` injects
 * `ApplicationPropertyStore` and is core's, so overriding the token is what lets the widget reach this backend with
 * no change to `@processpuzzle/base-widget`; an explicit provider outranks that store's own `providedIn: 'root'`.
 * `useFactory` rather than a class provider because `BaseEntityRestService` calls `inject()` in field initialisers,
 * so both have to be constructed inside an injection context.
 */
export function provideCustomApplicationProperties(): Provider[] {
  return [
    { provide: CustomApplicationPropertyService, useFactory: () => new CustomApplicationPropertyService(new CustomApplicationPropertyMapper()) },
    { provide: ApplicationPropertyStore, useFactory: () => new CustomApplicationPropertyStore(), deps: [CustomApplicationPropertyService] },
  ];
}
